import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ElTag from "@/components/functionals/ElTag.vue";

export const detallesSaltoComprobantesColumns = [
  {
    prop: "fecha",
    label: "Fecha",
    minWidth: 140,
    formatter: DatetimeFormatter
  },
  {
    prop: "descripcion",
    label: "Descripcion",
    minWidth: 210
  },
  {
    prop: "ncf",
    label: "NCF",
    minWidth: 120
  },

  {
    prop: "empresa",
    label: "Empresa",
    minWidth: 120
  },
  {
    prop: "status",
    label: "Estatus",
    minWidth: 120,
    formatter: ElTag
  }
];
